import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {NchPointCheckHcodeExcludeDto, Page} from "../../generated-model/model";
import {Observable} from "rxjs";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";

@Injectable({providedIn: "root"})
export class ExcludedHospitalsResource {
  http = inject(HttpClient);

  public save(dto: NchPointCheckHcodeExcludeDto): Observable<NchPointCheckHcodeExcludeDto> {
    return this.http.post<NchPointCheckHcodeExcludeDto>(`${environment.serverUrl}/api/excluded-hospitals`, dto);
  }

  public update(dto: NchPointCheckHcodeExcludeDto): Observable<NchPointCheckHcodeExcludeDto> {
    return this.http.put<NchPointCheckHcodeExcludeDto>(`${environment.serverUrl}/api/excluded-hospitals`, dto);
  }

  search(param: IgnoreNullHttpParams): Observable<Page<NchPointCheckHcodeExcludeDto>> {
    return this.http.get<Page<NchPointCheckHcodeExcludeDto>>(`${environment.serverUrl}/api/excluded-hospitals/search`, {params: param.toHttpParam()});
  }

  public remove(dto: NchPointCheckHcodeExcludeDto): Observable<void> {
    return this.http.delete<void>(`${environment.serverUrl}/api/excluded-hospitals/${dto.id?.hcode}/${dto.id?.dateOut}`,);
  }
}
